import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import { FRANJAS } from '../../utils/franjas';
import { formatDateISO, getTodayISO } from '../../utils/dateUtils';
import UbicacionEnMapa from '../mapa/UbicacionEnMapa';

// Sumar algo mío (29-oct-2026, técnico): un cliente de su libreta (o un lugar suelto) en una franja de su día.
// Lo ve en su recorrido, en violeta. El admin solo ve esa franja como "ocupado" (sin nombre ni datos).
// 2-nov-2026: la dirección se ve en el mapa mientras se escribe (como al cargar un cliente) y se ubica al
// guardar, así sale en el mapa de su día enseguida; y se puede anotar qué hay que hacer.
const INPUT = 'w-full h-11 px-3 rounded-xl bg-chip text-ink text-body outline-none placeholder:text-muted';
const proximosDias = () => Array.from({ length: 7 }, (_, i) => { const d = new Date(); d.setDate(d.getDate() + i); return formatDateISO(d); })
    .filter(f => new Date(`${f}T12:00:00`).getDay() !== 0);
const DIAS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const diaCorto = (f) => (f === getTodayISO() ? 'Hoy' : `${DIAS[new Date(`${f}T12:00:00`).getDay()]} ${Number(f.slice(8, 10))}`);

export default function SumarAlgoMioSheet({ fechaInicial = getTodayISO(), onCerrar, onListo }) {
    const [clientes, setClientes] = useState(null);
    const [clienteId, setClienteId] = useState('');
    const [titulo, setTitulo] = useState('');
    const [direccion, setDireccion] = useState('');
    const [fecha, setFecha] = useState(String(fechaInicial).slice(0, 10));
    const [franja, setFranja] = useState(null);
    const [detalle, setDetalle] = useState('');
    const [punto, setPunto] = useState(null);   // { lat, lng, manual } del mapa
    const [guardando, setGuardando] = useState(false);
    useEffect(() => { api.get('/mis-clientes').then(r => setClientes(Array.isArray(r.data) ? r.data : [])).catch(() => setClientes([])); }, []);
    const cli = (clientes || []).find(c => String(c.id) === String(clienteId));

    const guardar = async () => {
        if (!franja) { toast.error('Elegí la franja'); return; }
        setGuardando(true);
        try {
            await api.post('/ordenes/mi-recorrido/algo-mio', {
                fecha, franja, clientePropioId: cli ? cli.id : null,
                titulo: cli ? null : titulo, direccion: cli && !direccion ? null : direccion, detalle: detalle.trim() || null,
                ...(punto?.manual ? { lat: punto.lat, lng: punto.lng, manual: true } : {}),
            });
            toast.success('Listo: está en tu día como una visita tuya. El admin ve esa franja como ocupada.');
            onListo && onListo();
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo guardar'); }
        finally { setGuardando(false); }
    };
    const chip = (on) => `h-10 px-3 shrink-0 rounded-xl text-label font-black border ${on ? 'border-brand-red bg-[rgba(232,66,47,0.10)] text-ink' : 'border-black/10 dark:border-white/10 text-secondary'}`;
    return (
        <ModalShell titulo="Sumar algo mío" subtitulo="Un cliente tuyo en tu día" onCerrar={onCerrar}
            pie={<button type="button" disabled={guardando} onClick={guardar} className="w-full h-12 rounded-xl bg-[#7C3AED] text-white text-body font-black disabled:opacity-50">{guardando ? 'Guardando…' : 'Sumar a mi día'}</button>}>
            <div className="space-y-3">
                <select value={clienteId} onChange={e => { setClienteId(e.target.value); setDireccion(''); }} className={INPUT} aria-label="Cliente de tu libreta">
                    <option value="">{clientes === null ? 'Cargando tus clientes…' : 'Otro (lo escribo)'}</option>
                    {(clientes || []).map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
                {!cli && <input value={titulo} onChange={e => setTitulo(e.target.value)} placeholder="Cliente o lugar (ej. Juan Pérez)" className={INPUT} />}
                <input value={detalle} onChange={e => setDetalle(e.target.value)} placeholder="Qué hay que hacer (ej. limpieza y cambio de filtro)" className={INPUT} />
                <input value={direccion} onChange={e => setDireccion(e.target.value)} placeholder={cli?.direccion || 'Dirección (calle, altura, localidad)'} className={INPUT} />
                <UbicacionEnMapa direccion={direccion || cli?.direccion || ''} onCambio={setPunto} endpoint="/ordenes/mi-recorrido/ubicar" />
                <div className="flex gap-1.5 overflow-x-auto">{proximosDias().map(f => <button key={f} type="button" onClick={() => setFecha(f)} className={chip(fecha === f)}>{diaCorto(f)}</button>)}</div>
                <div className="grid grid-cols-2 gap-1.5">{FRANJAS.map(f => <button key={f.id} type="button" onClick={() => setFranja(f.id)} className={chip(franja === f.id)}>{f.rango}</button>)}</div>
                <p className="text-caption text-muted">Queda como una visita tuya: en tu recorrido (en violeta) y con Salí / Llegué / Terminé, como las demás. El admin solo ve esa franja como ocupada: no ve el nombre ni los datos de tu cliente.</p>
            </div>
        </ModalShell>
    );
}
